import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../../Components/Common/ChartsDynamicColor";

const ServicesOrgaApp = ( { label, data, dataColors } ) =>
{
  // console.log( 'label ServicesApp: ', label );
  // console.log( 'data ServicesApp: ', data );
  // console.log( 'dataColors ServicesApp: ', dataColors );

  const chartDonutBasicColors = getChartColorsArray( dataColors );
  const series = data;
  const options = {
    labels: label,
    chart: {
      height: 333,
      type: "donut",
    },
    legend: {
      position: "bottom",
    },
    stroke: {
      show: false,
    },
    dataLabels: {
      dropShadow: {
        enabled: false,
      },
    },
    colors: chartDonutBasicColors,
  };

  return (
    <ReactApexChart
      options={ options }
      series={ series }
      type="donut"
      height="333"
      className="apex-charts"
    />
  );
};



const RevenueTicketLineCharts = ( {period, data, labels, dataColors } ) =>
{
  var linechartBasicColors = getChartColorsArray( dataColors );
  const series = [ {
    name: "Revenue",
    data: data,
    labels: labels
  } ];

  var options = {
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      }
    },
    markers: {
      size: 4,
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'straight'
    },
    colors: linechartBasicColors,
    title: {
      text: `Revenues par ${period}`,
      align: 'left',
      style: {
        fontWeight: 500,
      },
    },

    xaxis: {
      categories: labels,
    }
  };
  return (
    <React.Fragment>
      <ReactApexChart
        options={ options }
        series={ series }
        type="line"
        height="350"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export { ServicesOrgaApp,  RevenueTicketLineCharts };
